import Config from '@/config.loader'
import Pusher from 'pusher-js'
import { mapGetters } from 'vuex'
export default {
    data() {
        return {
            pusher: null,
            logToConsole: false,
        }
    },
    beforeDestroy() {
        if (this.pusher) this.pusher.disconnect()
    },
    computed: {
        ...mapGetters({ config: 'site/config' }),
        filtersOn() {
            return (
                Object.keys(this.filters || {}).findIndex(
                    (filter) => !['order', 'page', 'itemsPerPage'].includes(filter)
                ) > 0
            )
        },
    },
    methods: {
        initializePusher() {
            const wsHost = Config.getConfigValue('VUE_APP_PUSHER_WS_HOST') || 'events.dev.ordit.hu'
            const wsPort = Config.getConfigValue('VUE_APP_PUSHER_WS_PORT') || 443
            const wsEventsProtocol =
                Config.getConfigValue('VUE_APP_PUSHER_WS_EVENTS_PROTOCOL') || 'https://'
            const authEndpoint =
                Config.getConfigValue('VUE_APP_PUSHER_AUTH_API') || '/api/v1/broadcasting/auth'
            this.pusher = new Pusher(Config.getConfigValue('VUE_APP_PUSHER_APP_KEY') || 'Events', {
                wsHost: wsHost,
                wsPort: wsPort,
                wssHost: wsHost,
                wssPort: wsPort,
                enabledTransports: ['ws', 'wss'],
                authEndpoint: `${wsEventsProtocol}${wsHost}:${wsPort}${authEndpoint}`,
                auth: {
                    headers: this.$user.authorizationHeader,
                },
            })
            this.pusher.logToConsole = this.logToConsole
            Pusher.log = (msg) => {
                // eslint-disable-next-line no-console
                if (this.logToConsole) console.debug(`%c${msg}`, 'color: #55da95')
            }
            Pusher.err = (msg) => {
                // eslint-disable-next-line no-console
                console.error(`%c[PUSHER ERROR]${msg}`, 'color: #f00')
            }

            this.pusher.connection.bind('error', function (err) {
                if (err.error?.data?.code === 4004) Pusher.err('Over limit!')
                else Pusher.err(err)
            })
        },
    },
}
